export const TOKEN_EXPIRED = 'Unable to validate token reason: Token is not valid';
export const REDEMPTION_CODE_ALREADY_USED_BY_ANOTHER_USER =
    'unable to bind, another user already used this PromoCode';
